// built in
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types'
//external
import { Button, Col, Form, Row, Select } from 'antd';
//internal
import styles from './styles'
import DateRangeSelect from './DateRangeSelect'
import DashboardOptions from './DashboardOptions'
import FilterContext from './FilterContext'

const FilterComponent = ({
    dimensionOptions,
    filterState,
    handleFilterChange,
    handleApply,
    handleResetAll,
    handleExport,
    exportOptions,
    afterUpload,
    clientName
}) => {


    const [form] = Form.useForm()


    const [componentState, setComponentState] = useState({
        export: false,
        exportOption: "currentFilter",
        defaultLayout: true
    })

    const contextValues = {
        dimensionOptions,
        filterState,
        handleFilterChange,
        handleApply,
        handleResetAll,
        handleExport,
        exportOptions,
        afterUpload,
        clientName,
        componentState,
        setComponentState
    }


    const onDateRangeChange = useCallback((values) => {
        handleFilterChange('dateRange', values)
    })


    useEffect(() => {
        console.log("component state", componentState)
        if (componentState.export) {

            setTimeout(() => {
                handleExport({ ...componentState })
            }, 100)

            setComponentState({
                ...componentState,
                export: false,
                defaultLayout: true
            })
        }

    }, [componentState])

    const DimensionSelect = ({ dimensionOption }) => {
        return (
            <Col>
                <Form.Item
                    label={
                        <label style={styles.formLabel()}>
                            {dimensionOption.label?.toUpperCase()}
                        </label>
                    }>
                    <Select
                        value={filterState[dimensionOption.value]}
                        style={styles.inputSize()}
                        onChange={(value) => handleFilterChange(dimensionOption.value, value)}
                        options={dimensionOption.options}
                    />
                </Form.Item>
            </Col>
        )
    }

    return (
        <>
            <FilterContext.Provider value={contextValues}>
                <Form
                    form={form}
                    layout="vertical"
                    style={styles.form()}
                >
                    <Row gutter={[32, 16]} justify='space-between' align='middle'>
                        <Col flex='auto'>
                            <Row gutter={[32, 0]}>
                                {
                                    dimensionOptions.map((dimensionOption, idx) => {
                                        return <DimensionSelect dimensionOption={dimensionOption} key={idx} />
                                    })
                                }
                                <DateRangeSelect
                                    dateRange={filterState.dateRange}
                                    handleDateRangeChange={onDateRangeChange}
                                />
                            </Row>
                        </Col>
                        <Col>
                            <DashboardOptions />
                        </Col>

                    </Row>
                    <Row gutter={[16, 16]} justify='end' align='middle'>
                        <Col>
                            <Button
                                type="link"
                                onClick={handleResetAll}
                            >
                                Reset all
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                onClick={handleApply}
                            >
                                Apply
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </FilterContext.Provider>
        </>

    )

}

FilterComponent.propTypes = {
    dimensionOptions: PropTypes.arrayOf(PropTypes.object),
    filterState: PropTypes.object,
    handleFilterChange: PropTypes.func,
    handleApply: PropTypes.func,
    handleResetAll: PropTypes.func,
    exportOptions: PropTypes.arrayOf(PropTypes.object),
    handleExport: PropTypes.func,
    afterUpload: PropTypes.func
}

FilterComponent.defaultProps = {
    dimensionOptions: [],
    filterState: {},
    handleFilterChange: () => {
    },
    handleApply: () => {
    },
    handleResetAll: () => {
    },
    exportOptions: [],
    handleExport: () => {
    },
    afterUpload: () => {
    }
}

export default FilterComponent